import { render } from "./OurServices.vue?vue&type=template&id=1ccdaede&scoped=true"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"

import "./OurServices.vue?vue&type=style&index=0&id=1ccdaede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccdaede"],['__file',"OurServices.vue"]])

export default __exports__